import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import moment from 'moment';

// Services
import OnboardingService from 'services/OnboardingService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class OnboardingQuestionnaireResponseModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                instructorID: opts.id,
                onboarding: null
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        this.setState({
            isLoading: true
        });
        const onboarding = await OnboardingService.get(this.state.instructorID);
        this.setState({
            isLoading: false,
            onboarding
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    //------------------------------------------------------------------------------

    render() {
        const {
            isOpen,
            isLoading
        } = this.state;

        if (!isOpen) {
            return null;
        }
        
        return (
            <Modal show className="onboarding-questionnaire-response-modal">
                {isLoading ? <Modal.Body><Loader /></Modal.Body> : this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            onboarding,
            isSuccess
        } = this.state;

        return (<>
            <Modal.Body>

                {this.renderPage1()}
                {this.renderPage2()}
                {this.renderPage3()}
                
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary me-auto" onClick={e => this.close()}>
                    Close
                </button>
            </Modal.Footer>
        </>);
    }

    renderPage1() {
        const {
            onboarding
        } = this.state;

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Please enter your full name</Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.instructor.firstName}{' '}
                    {onboarding.instructor.lastName}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    You must hold the AWS Solutions Architect certification as a prerequisite.<br />
                    Please enter the Credly link to verify your accreditation.
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.credlyURL ?
                        <>{onboarding.credlyURL} - <a href={onboarding.credlyURL} target="_blank">Click</a></> :
                        <>(Unspecified)</>
                    }
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    Please include the Credly link(s) to other AWS certifications that you hold.
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.otherCertLinks || '(Unspecified)'}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    Are you an Amazon Authorised Instructor already?
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.instructor.isExistingAAI ? 'Yes' : 'No'}
                </p>
            </Form.Group>

        </>);
    }

    renderPage2() {
        const {
            onboarding
        } = this.state;

        return (<>

            {!onboarding.instructor.isExistingAAI &&
                <Form.Group className="mb-3">
                    <Form.Label>Tell us in your own words why you want to become an AAI.</Form.Label>
                    <p className="form-control-plaintext">
                        {onboarding.whyWantToBecomeAAI || '(Unspecified)'}
                    </p>
                </Form.Group>
            }

            {/*
            {onboarding.instructor.isExistingAAI && <>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Please select the classes you are approved to deliver
                    </Form.Label>
                    <p className="form-control-plaintext">
                        {onboarding.instructor.courses.map(c => c.courseName || c.name).join(', ')}
                    </p>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>
                        Are you a standard or champion AAI?
                    </Form.Label>
                    <p className="form-control-plaintext">
                        {onboarding.existingAAIStatus || '(Unspecified)'}
                    </p>
                </Form.Group>

            </>}
            */}

            <Form.Group className="mb-3">
                <Form.Label>
                    Can we double check you have no contractual obligations which might stop you from being able to deliver in the freelancer programme?
                </Form.Label><p className="form-control-plaintext">
                    {onboarding.noOtherContractualObligations ? 'I confirm' : 'NOT CONFIRMED'}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>What is your current work situation, please select from the below:</Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.currentWorkSituation || '(Unspecified)'}
                </p>
                {onboarding.currentWorkSituation == 'Other' &&
                    <p className="form-control-plaintext">
                        {onboarding.currentworkSituationOther || '(Unspecified)'}
                    </p>
                }
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>
                    You need to be able to offer us a guaranteed 15 days per year, but how many do you estimate you could give us?
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.canCommitDays || '(Unspecified)'}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    What hours can you work and in which time zone(s)?
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.hours || '(Unspecified)'}
                </p>
            </Form.Group>

        </>);
    }

    renderPage3() {
        const {
            onboarding,
            languages,
            countries,
            isLoadingCities,
            cities
        } = this.state;

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>
                    Which languages can you deliver in?
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.instructor.languages.map(l => l.name).join(', ')}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    Please enter your preferred email address
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.instructor.email || '(Unspecified)'}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    Please enter your contact number
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.instructor.mobileNumber || '(Unspecified)'}
                </p>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>
                    Please enter your home city/town
                </Form.Label>
                <p className="form-control-plaintext">
                    Country: {onboarding.instructor.country ? onboarding.instructor.country.name : '(Unspecified)'}<br />
                    City: {onboarding.instructor.city ? onboarding.instructor.city.name : '(Unspecified)'}
                </p>
            </Form.Group>

            <Form.Group>
                <Form.Label>
                    Thank you for your answers. Please add any other detail that you feel is relevant to the position.
                </Form.Label>
                <p className="form-control-plaintext">
                    {onboarding.otherDetails || '(Unspecified)'}
                </p>
            </Form.Group>


        </>);
    }

}

export default OnboardingQuestionnaireResponseModal;